"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSnackbar = exports.SnackbarProvider = exports.SnackbarContext = void 0;

var react_1 = __importDefault(require("react"));

var icons_1 = require("@material-ui/icons");

var core_1 = require("@material-ui/core");

var Snackbar_1 = __importDefault(require("@material-ui/core/Snackbar"));

var Alert_1 = __importDefault(require("@material-ui/lab/Alert"));

var useStyles_1 = __importDefault(require("../../utils/useStyles"));

var useSnackbar_module_scss_1 = __importDefault(require("./useSnackbar.module.scss"));

var AUTO_HIDE_DURATION = 6000;
exports.SnackbarContext = react_1.default.createContext({});

var Provider = function Provider(_a) {
  var children = _a.children;
  var styles = useStyles_1.default(useSnackbar_module_scss_1.default);

  var _b = react_1.default.useState(),
      message = _b[0],
      setMessage = _b[1];

  var _c = react_1.default.useState(false),
      open = _c[0],
      setOpen = _c[1];

  var _d = react_1.default.useState(),
      alertType = _d[0],
      setAlertType = _d[1];
  /* @ts-ignore: Not used event */


  var handleClose = function handleClose(event, reason) {
    if (reason === void 0) {
      reason = '';
    }

    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  var context = {
    showSnackbar: function showSnackbar(message, alertType) {
      setMessage(message);
      setOpen(true);
      setAlertType(alertType || 'success');
    }
  };
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(exports.SnackbarContext.Provider, {
    value: context
  }, children), react_1.default.createElement(Snackbar_1.default, {
    "aria-label": 'status message',
    open: open,
    autoHideDuration: AUTO_HIDE_DURATION,
    onClose: handleClose
  }, react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Alert_1.default, {
    classes: {
      root: styles.alert
    },
    severity: alertType
  }, message, react_1.default.createElement(core_1.IconButton, {
    classes: {
      root: styles.closeButton
    },
    "aria-label": 'close',
    onClick: handleClose
  }, react_1.default.createElement(icons_1.Close, null))))));
};

exports.SnackbarProvider = react_1.default.memo(Provider);

function useSnackbar() {
  return react_1.default.useContext(exports.SnackbarContext);
}

exports.useSnackbar = useSnackbar;